function toggleChat() {
    const popup = document.getElementById('chatPopup');
    popup.style.display = popup.style.display === 'none' || popup.style.display === '' ? 'flex' : 'none';
    
    if(popup.style.display === 'flex') {
        updateGreeting();
    }
}

function updateGreeting() {
    const hour = new Date().getHours();
    let greeting = '';
    
    if(hour >= 5 && hour < 12) {
        greeting = 'Good Morning';
    } else if(hour >= 12 && hour < 17) {
        greeting = 'Good Afternoon';
    } else {
        greeting = 'Good Evening';
    }
    
    document.getElementById('greetingText').textContent = greeting;
}

function selectMessage(message) {
    document.getElementById('chatInput').value = message;
}

function sendMessage() {
    const message = document.getElementById('chatInput').value.trim();
    if(message) {
        const encodedMessage = encodeURIComponent(message);
        window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`, '_blank');
        document.getElementById('chatInput').value = '';
    }
}

// Allow sending message with Enter key
document.getElementById('chatInput').addEventListener('keypress', function(e) {
    if(e.key === 'Enter') {
        sendMessage();
    }
});

// Initialize greeting on page load
document.addEventListener('DOMContentLoaded', function() {
    updateGreeting();
});